/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum FieldSubType {
	None = 'None',
	SingleLine = 'SingleLine',
	MultipleLines = 'MultipleLines',
	Integer = 'Integer',
	Decimal = 'Decimal',
	Percent = 'Percent',
	DropDown = 'DropDown',
	RadioButtons = 'RadioButtons',
	SingleSelectCards = 'SingleSelectCards',
	Checkboxes = 'Checkboxes',
	MultiSelectCards = 'MultiSelectCards',
	Checkbox = 'Checkbox',
	Toggle = 'Toggle',
	Date = 'Date',
	Time = 'Time',
	DateTime = 'DateTime',
	USAddress = 'USAddress',
	InternationalAddress = 'InternationalAddress',
	USPhone = 'USPhone',
	InternationalPhone = 'InternationalPhone',
	Currency = 'Currency',
	YesNo = 'YesNo',
	Password = 'Password',
}
